/* eslint-disable @typescript-eslint/no-empty-function */
import { CommonModule } from '@angular/common';
import { Component, forwardRef, signal } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

import {
  CdkDragDrop,
  DragDropModule,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { Icon } from '../icon/icon.component';
import { Spinner } from '../spinner/spinner.component';
import { FileItem, FileUploaderAdapter } from './file-uploader.adapter';

@Component({
  selector: 'lepi-file-uploader',
  standalone: true,
  imports: [CommonModule, DragDropModule, Icon, FormsModule, Spinner],
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileUploader),
      multi: true,
    },
  ],
})
export class FileUploader extends FileUploaderAdapter {
  // 드래그/드롭 시 드래그가 끝났는지 여부
  isDragOvered = signal(false);

  onDragOver(e: DragEvent) {
    this.isDragOvered.set(true);
    e.preventDefault();
  }

  onDragLeave(e: DragEvent) {
    this.isDragOvered.set(false);
    e.preventDefault();
  }

  onDragDrop(e: DragEvent) {
    this.isDragOvered.set(false);
    this.onFileDrop(e);
  }

  openImage(url: string) {
    window.open(url);
  }

  onDrop(ev: CdkDragDrop<FileItem[]>) {
    if (ev.container === ev.previousContainer) {
      this.items.update(items => {
        const temp = [...items];
        moveItemInArray(temp, ev.previousIndex, ev.currentIndex);
        return temp;
      });
      this.setValue(this.items().map(item => item.url));
    }
  }
}
